import React from "react";
import Modal from "@components/common/Modal/Modal";
import CreateLabForm from "../CreateLabForm/CreateLabForm";
import type { CreateLabRequest, Lab } from "../../types";
import AddIcon from "@mui/icons-material/Add";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { EditActionIcon } from "@components/common/Icons/ActionIcons";
import { useLabModal } from "../../hooks/useLabModal";
import { useTranslation } from "react-i18next";

interface CreateLabModalProps {
	open: boolean;
	onClose: () => void;
	initialValues?: Lab;
	isEdit?: boolean;
	isView?: boolean;
}

const CreateLabModal: React.FC<CreateLabModalProps> = ({
	open,
	onClose,
	initialValues,
	isEdit = false,
	isView = false,
}) => {
	const { t } = useTranslation();
	const { handleCreateLab, isCreatingLab } = useLabModal();
	const handleSubmit = async (data: CreateLabRequest) => {
		if (isView) return;
		if (!isEdit) {
			await handleCreateLab(data);
		}
	};

	const isSubmitting = isView ? false : isCreatingLab;
	const title = isView
		? t("feature.courseBuilder.labs.modals.viewLab")
		: isEdit
			? t("feature.courseBuilder.labs.modals.editLab")
			: t("feature.courseBuilder.labs.modals.addLab");
	const icon = isView ? <VisibilityOutlinedIcon /> : isEdit ? <EditActionIcon /> : <AddIcon />;

	return (
		<Modal
			isOpen={open}
			onClose={onClose}
			title={title}
			icon={icon}
			width="max-w-4xl"
			height="h-auto"
			showCloseIcon={!isSubmitting}>
			<div className="overflow-y-auto">
				<CreateLabForm
					onSubmit={handleSubmit}
					onCancel={onClose}
					isSubmitting={isSubmitting}
					initialValues={initialValues}
					isEdit={isEdit}
					isView={isView}
				/>
			</div>
		</Modal>
	);
};

export default CreateLabModal;
